import { FindDealerFields, FindDealerParams, FindDealerProps } from '../types/findDealer.types';
import { TImageField, TLinkField, TSitecoreContext, TStringField } from '../../../types/sitecore.types';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { THeadingTag } from '../../../types/types';

export class FindDealerModel {
  private readonly fields?: FindDealerFields;
  private readonly rendering?: ComponentRendering;
  private readonly params?: FindDealerParams;
  private readonly context?: TSitecoreContext;

  constructor(props: FindDealerProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
    this.params = props?.params;
    this.context = props?.sitecoreContext;
  }

  get title(): TStringField {
    return this.fields?.title || {};
  }

  get content(): TStringField {
    return this.fields?.description || {};
  }

  get backgroundImage(): TImageField | undefined {
    return this.fields?.image;
  }

  get backgroundImageMobile(): TImageField | undefined {
    return this.fields?.mobileImage;
  }

  get defaultBgDesktopImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.desktopImageData?.findADealer,
      },
    };
  }

  get defaultBgMobileImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.mobileImageData?.findADealer,
      },
    };
  }

  get desktopBgImage(): TImageField | undefined {
    return this.backgroundImage?.value?.src ? this.backgroundImage : this.defaultBgDesktopImage;
  }

  get mobileBgImage(): TImageField | undefined {
    return this.backgroundImageMobile?.value?.src ? this.backgroundImageMobile : this.defaultBgMobileImage;
  }

  get link(): TLinkField | undefined {
    return this.fields?.link;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get dataSource(): string | undefined {
    return this.rendering?.dataSource;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
